<div class="flex h-full w-full flex-col">
  <div class="flex flex-col gap-2 border-b border-gray-200 p-3">
    <dojo-search-input
      [formCtrl]="searchCtrl"
      placeholder="Search topics..."
      [compact]="true"
      [size]="'xs'"
      (searchChanged)="onSearch($event)"
    ></dojo-search-input>

    <div class="flex items-center justify-between gap-2">
      <span class="text-xs text-neutral-900">Incl. dependencies</span>
      <mat-slide-toggle
        class="small"
        [formControl]="includeDependenciesCtrl"
        (change)="includeDependenciesChanged.emit($event.checked)"
        color="primary"
        style="transform: scale(0.8)"
      ></mat-slide-toggle>
    </div>
  </div>
  <div class="flex-1 overflow-hidden">
    <ag-grid-angular
      class="ag-theme-unthemed h-full w-full"
      [gridOptions]="gridOptions"
      [rowData]="explorerNodes()"
      (gridReady)="onGridReady($event)"
      (selectionChanged)="onSelectionChanged($event)"
    />
  </div>
</div>
